import React, { useEffect, useState, useRef, useReducer } from 'react';
import { Col, Form, Modal, Radio, Row, Table, Tabs } from 'antd';
import { Checkbox, InfoBox, MobileTabBar, Select } from 'components';
import classNames from 'classnames';

import ExportFileIcon from 'assests/icons/export-file.icon';
import NewContact from 'assests/icons/new-contact.icon';
import ImportExcelIcon from 'assests/icons/import-excel.icon';
import CheckBorderBoldIcon from 'assests/icons/check-border-bold.icon';
import BanIcon from 'assests/icons/ban.icon';

import './black-list.less';
import '../GuildePage/guide-page.less';
import '../Checkbox/checkbox.less';
import { Button, Input, SelectFile } from '../index';
import RightChevronIcon from 'assests/icons/right-chevron.icon';
import DownChevronIcon from 'assests/icons/down-chevron.icon';
import UploadIcon from 'assests/icons/upload.icon';
import SearchIcon from 'assests/icons/search.icon';
import DeleteIcon from 'assests/icons/delete.icon';

const { TabPane } = Tabs;

const BlackList = () => {
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);
  const [selectedItems, setSelectedItems] = useState(null);
  const [importFileModal, setImportFileModal] = useState(false);
  const [addRowModal, setAddRowModal] = useState(false);
  const [removeFromBlackListModal, setRemoveFromBlackListModal] = useState(
    false
  );
  const [testSelectedRow, setTestSelectedRow] = useState([]);

  const [contentName, setContentName] = useState('group--1');

  const [fileList, setFileList] = useState([]);
  const [groupImportFile, setGroupImportFile] = useState(false);
  const [form] = Form.useForm();

  const columns = [
    {
      title: '',
      dataIndex: 'check',
      children: [
        {
          title: () => (
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  arrayList.map((item) => {
                    item.checked = true;
                    return item;
                  });
                  setTestSelectedRow(arrayList);
                } else {
                  arrayList.map((item) => {
                    item.checked = false;
                    return item;
                  });
                  setTestSelectedRow([]);
                }
                forceUpdate();
              }}
            />
          ),
          dataIndex: 'check',
          render: (a, selectedRows, c) => (
            <>
              <Checkbox
                checked={selectedRows.checked}
                onChange={(e) => {
                  selectedRows.checked = e.target.checked;
                  if (selectedRows.checked === true) {
                    setTestSelectedRow((prevArray) => [
                      ...prevArray,
                      selectedRows,
                    ]);
                  } else {
                    setTestSelectedRow(
                      testSelectedRow.filter((e) => e !== selectedRows)
                    );
                  }
                  forceUpdate();
                }}
              />
            </>
          ),
        },
      ],
    },
    {
      title: 'Telefon No',
      children: [
        {
          title: 'Tümünü Seç',
          dataIndex: 'phone',
        },
      ],
    },
    {
      title: 'Eklenme Tarihi',
      children: [
        {
          title: () => (
            <div className="table-group-actions">
              {testSelectedRow.length > 0 ? (
                <>
                  <span>{testSelectedRow.length} Kişi Seçildi</span>
                  <div className="group-actions">
                    <button
                      onClick={() => {
                        setRemoveFromBlackListModal(true);
                      }}
                      type="button"
                    >
                      <DeleteIcon />
                      <span>Kara Listeden Çıkar</span>
                    </button>
                  </div>
                </>
              ) : null}
            </div>
          ),
          dataIndex: 'addedDate',
          render: (text) => (
            <>
              <span>{text}</span>
              <div className="row-edit">
                <button
                  onClick={() => {
                    setRemoveFromBlackListModal(true);
                  }}
                  type="button"
                >
                  <CheckBorderBoldIcon />
                </button>
              </div>
            </>
          ),
        },
      ],
    },
  ];
  const columnsV2 = [
    {
      title: '',
      dataIndex: 'check',
      children: [
        {
          title: () => (
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  arrayList.map((item) => {
                    item.checked = true;
                    return item;
                  });
                  setTestSelectedRow(arrayList);
                } else {
                  arrayList.map((item) => {
                    item.checked = false;
                    return item;
                  });
                  setTestSelectedRow([]);
                }
                forceUpdate();
              }}
            />
          ),
          dataIndex: 'check',
          render: (a, selectedRows, c) => (
            <>
              <Checkbox
                checked={selectedRows.checked}
                onChange={(e) => {
                  selectedRows.checked = e.target.checked;
                  if (selectedRows.checked === true) {
                    setTestSelectedRow((prevArray) => [
                      ...prevArray,
                      selectedRows,
                    ]);
                  } else {
                    setTestSelectedRow(
                      testSelectedRow.filter((e) => e !== selectedRows)
                    );
                  }
                  forceUpdate();
                }}
              />
            </>
          ),
        },
      ],
    },
    {
      title: 'Telefon No',
      children: [
        {
          title: 'Tümünü Seç',
          dataIndex: 'phone',
        },
      ],
    },
    {
      title: 'Çıkarılma Tarihi',
      children: [
        {
          title: () => (
            <div className="table-group-actions">
              {testSelectedRow.length > 0 ? (
                <>
                  <span>{testSelectedRow.length} Kişi Seçildi</span>
                  <div className="group-actions">
                    <button type="button">
                      <BanIcon />
                      <span>Kara Listeye Ekle</span>
                    </button>
                  </div>
                </>
              ) : null}
            </div>
          ),
          dataIndex: 'addedDate',
          render: (text) => (
            <>
              <span>{text}</span>
              <div className="row-edit">
                <button type="button">
                  <BanIcon />
                </button>
              </div>
            </>
          ),
        },
      ],
    },
  ];

  const data = [
    {
      key: '1',
      phone: '+905300854144',
      addedDate: '20.10.1999',
    },
    {
      key: '2',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '3',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '4',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '5',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '6',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '7',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '8',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '9',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '10',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '6',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '8',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '9',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '10',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '6',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '8',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '9',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '10',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '6',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '8',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '9',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '10',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '6',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '8',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '9',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '10',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '6',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '8',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '9',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '10',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '6',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '8',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '9',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '10',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '6',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '7',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '8',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '9',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
    {
      key: '10',
      phone: '+90512499909',
      addedDate: '10.02.2020',
    },
  ];
  const changeGroupList = [
    'Samsung Kullanıcıları',
    'General Mobile Kullanıcıları',
    'Bizden Telefon Almamış Müşterilerimiz',
    'Son Telefon Satın Alma Tarihi 1 Yıldan Son Telefon Satın Alma Tarihi 1 Yıldan Ö...',
    'Lorem ipsum2 2dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum .',
    'Lorem ipsum3 dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum .',
    'Lorem ipsum4 dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum .',
    'Lorem ipsum5 dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum .',
    'Lorem ipsum6 dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum .',
  ];

  const selectFileRef = useRef(null);

  const [arrayList, setArrayList] = useState(data);

  const onInputChange = (value) => {
    const inputValue = value.toUpperCase();

    const filteredArray = data.filter((item, index) => {
      return item.phone.toUpperCase().indexOf(inputValue) > -1;
    });
    setArrayList(filteredArray);
  };

  return (
    <div className="messages-tab black-list">
      <div className="container">
        <h1 className="section__title">Kara Liste</h1>
        <div className="box">
          <div className="group-titles">
            <div className="sub-groups">
              <ul>
                <li
                  className={classNames({ active: contentName === 'group--1' })}
                  onClick={() => {
                    setContentName('group--1');
                  }}
                >
                  <span>Kara Listedeki Kullanıcılar</span>
                  <RightChevronIcon />
                </li>
                <li
                  className={classNames({ active: contentName === 'group--2' })}
                  onClick={() => {
                    setContentName('group--2');
                  }}
                >
                  <span>Kara Listeden Çıkanlar</span>
                  <RightChevronIcon />
                </li>
              </ul>
            </div>
          </div>
          <Tabs
            defaultActiveKey="1"
            onChange={(item) => {
              setContentName(`group--${item}`);
            }}
            renderTabBar={(props, Item) => {
              return <MobileTabBar props={props} item={Item} />;
            }}
          >
            <TabPane tab="Kara Listedeki Kullanıcılar" key="1"></TabPane>
            <TabPane tab="Kara Listeden Çıkanlar" key="2"></TabPane>
          </Tabs>
          {contentName === 'group--1' ? (
            <div className="group-members">
              <div className="group-members__header">
                <strong className="group-members__title">
                  Kara Listedeki Kullanıcılar
                </strong>
                <div className="group-actions">
                  <button
                    onClick={() => {
                      console.log('dışa aktar');
                    }}
                    type="button"
                  >
                    <ExportFileIcon />
                    <span>Dışa aktar</span>
                  </button>
                  <button
                    onClick={() => {
                      setAddRowModal(true);
                    }}
                    type="button"
                  >
                    <NewContact />
                    <span>Yeni Kişi</span>
                  </button>
                  <div>
                    <input
                      type="file"
                      ref={selectFileRef}
                      onChange={(e) => {
                        setFileList(e.target.files);
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => setGroupImportFile(!groupImportFile)}
                    >
                      <ImportExcelIcon />
                      İçe Aktar
                      <DownChevronIcon />
                    </button>
                    {groupImportFile ? (
                      <div className="collapse">
                        <div className="select-ready-messages">
                          <div className="status">
                            <UploadIcon />
                          </div>
                          <div className="messages-area">
                            <span>Excel'den İçe Aktar</span>
                          </div>
                          <div className="upload-action">
                            <Button
                              type="ghost"
                              onClick={() => {
                                selectFileRef.current.click();
                                setImportFileModal(true);
                              }}
                            >
                              Seç
                            </Button>
                          </div>
                        </div>
                        <span>
                          Rehber kayıtlarınızı oluşturabileceğiniz örnek Excel
                          dosyasını indirmek için{' '}
                          <a  href="/samples/ornekKaraliste.xlsx" download>tıklayın.</a>
                        </span>
                      </div>
                    ) : null}
                  </div>

                  <Modal
                    title="Dosyayı İçeri Aktar"
                    visible={importFileModal}
                    onCancel={() => setImportFileModal(false)}
                    footer={null}
                  >
                    <Form form={form} name="import-file">
                      <Form.Item
                        name="group-name"
                        messageVariables={{ label: 'name' }}
                      >
                        <Input type="text" name="group-name" label="Grup Adı" />
                      </Form.Item>
                      <Form.Item
                        name="select-file"
                        messageVariables={{ label: 'file' }}
                      >
                        <SelectFile
                          uploaderRef={selectFileRef}
                          
                          type="file"
                          fileList={fileList}
                          title={<span>Excel'den İçe Aktar</span>}
                          icon={<UploadIcon />}
                        />
                      </Form.Item>
                      <div className="modal-action">
                        <Button
                          shape="round"
                          type="ghost"
                          onClick={() => setImportFileModal(false)}
                        >
                          Vazgeç
                        </Button>
                        <Button
                          disabled
                          key="confirm"
                          type="primary"
                          onClick={() => setImportFileModal(false)}
                        >
                          Kaydet
                        </Button>
                      </div>
                    </Form>
                  </Modal>

                  <Modal
                    title="Kişi Ekle"
                    visible={addRowModal}
                    onCancel={() => setAddRowModal(false)}
                    footer={null}
                  >
                    <Form form={form} name="add-row">
                      <Form.Item
                        name="add-row-number"
                        messageVariables={{ label: 'number' }}
                      >
                        <Input
                          type="tel"
                          name="add-row-number"
                          label="Telefon Numarası"
                        />
                      </Form.Item>
                      <Form.Item
                        name="add-row-name"
                        messageVariables={{ label: 'name' }}
                      >
                        <Input
                          type="text"
                          name="add-row-name"
                          label="Kişi Adı"
                        />
                      </Form.Item>
                      <Form.Item
                        name="add-row-mail"
                        messageVariables={{ label: 'e-mail' }}
                      >
                        <Input
                          type="mail"
                          name="add-row-mail"
                          label="E-Posta Adresi"
                        />
                      </Form.Item>
                      <div className="modal-action">
                        <Button
                          shape="round"
                          type="ghost"
                          onClick={() => setAddRowModal(false)}
                        >
                          Vazgeç
                        </Button>
                        <Button
                          disabled
                          key="confirm"
                          type="primary"
                          onClick={() => setAddRowModal(false)}
                        >
                          Kaydet
                        </Button>
                      </div>
                    </Form>
                  </Modal>
                </div>
              </div>
              <InfoBox
                type="warning"
                content={
                  <p>
                    Bu listede SMS reddetme hakkını kullanmış veya sizin
                    tarafınızdan kara listeye eklenmiş numaraları görmektesiniz.
                    Listede yer alan numaralara SMS gönderimi yapamazsınız.
                    İstediğiniz numaraları kara listeden çıkarabilir veya kara
                    listeye yeni numaralar ekleyebilirsiniz.
                  </p>
                }
              />
              <div className="group-members__search">
                <Input
                  prefix={<SearchIcon />}
                  placeholder="Kara Liste İçerisinde Ara..."
                  autoComplete="off"
                  style={{ width: '100%' }}
                  onChange={(e) => onInputChange(e.target.value)}
                />
              </div>
              <Table
                columns={columns}
                scroll={{ y: 610 }}
                dataSource={arrayList}
                className="table--guide table--black-list"
                pagination={{ total: 100, position: ['bottomCenter'] }}
              />

              <Modal
                title="Kara Listeden Çıkar"
                visible={removeFromBlackListModal}
                onCancel={() => setRemoveFromBlackListModal(false)}
                footer={null}
              >
                <p>
                  Seçtiğiniz 120 kayıt kara listeden çıkarılacaktır. Bu
                  kayıtlara “Kara Listeden Çıkanlar” bölümünden ulaşabilirsiniz.
                </p>
                <div className="modal-action">
                  <Button
                    shape="round"
                    type="ghost"
                    onClick={() => setRemoveFromBlackListModal(false)}
                  >
                    Vazgeç
                  </Button>
                  <Button
                    key="confirm"
                    type="primary"
                    onClick={() => setRemoveFromBlackListModal(false)}
                  >
                    Çıkar
                  </Button>
                </div>
              </Modal>
            </div>
          ) : (
            <div className="group-members">
              <div className="group-members__header">
                <strong className="group-members__title">
                  Kara Listeden Çıkanlar
                </strong>
                <div className="group-actions">
                  <button
                    onClick={() => {
                      console.log('dışa aktar');
                    }}
                    type="button"
                  >
                    <ExportFileIcon />
                    <span>Dışa Aktar</span>
                  </button>
                  <button
                    onClick={() => {
                      setAddRowModal(true);
                    }}
                    type="button"
                  >
                    <NewContact />
                    <span>Yeni Kişi</span>
                  </button>

                  <Modal
                    title="Kişi Ekle"
                    visible={addRowModal}
                    onCancel={() => setAddRowModal(false)}
                    footer={null}
                  >
                    <Form form={form} name="add-row">
                      <Form.Item
                        name="add-row-number"
                        messageVariables={{ label: 'number' }}
                      >
                        <Input
                          type="tel"
                          name="add-row-number"
                          label="Telefon Numarası"
                        />
                      </Form.Item>
                      <Form.Item
                        name="add-row-name"
                        messageVariables={{ label: 'name' }}
                      >
                        <Input
                          type="text"
                          name="add-row-name"
                          label="Kişi Adı"
                        />
                      </Form.Item>
                      <Form.Item
                        name="add-row-mail"
                        messageVariables={{ label: 'e-mail' }}
                      >
                        <Input
                          type="mail"
                          name="add-row-mail"
                          label="E-Posta Adresi"
                        />
                      </Form.Item>
                      <div className="modal-action">
                        <Button
                          shape="round"
                          type="ghost"
                          onClick={() => setAddRowModal(false)}
                        >
                          Vazgeç
                        </Button>
                        <Button
                          disabled
                          key="confirm"
                          type="primary"
                          onClick={() => setAddRowModal(false)}
                        >
                          Kaydet
                        </Button>
                      </div>
                    </Form>
                  </Modal>
                </div>
              </div>
              <InfoBox
                type="warning"
                content={
                  <p>
                    Bu listede daha önceden kara listenize eklenmiş fakat sonra
                    sizin tarafınızdan kara listeden çıkartılmış numaraları
                    görmektesiniz. Listede yer alan numaralara SMS gönderimi
                    yapabilirsiniz. İstediğiniz numaraları tekrardan kara
                    listeye ekleyebilirsiniz.
                  </p>
                }
              />
              <div className="group-members__search">
                <Input
                  prefix={<SearchIcon />}
                  placeholder="Grup İçerisinde Ara..."
                  autoComplete="off"
                  style={{ width: '100%' }}
                  onChange={(e) => onInputChange(e.target.value)}
                />
              </div>
              <Table
                columns={columnsV2}
                scroll={{ y: 610 }}
                dataSource={arrayList}
                className="table--guide table--black-list"
                pagination={{ total: 100, position: ['bottomCenter'] }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BlackList;
